import React from 'react';
import { IStandardDocumentVersionData } from '../../../../types/order/documents/shared/interfaces';
import { PolicyTypeEnum } from '../../../../policyUI/classes/PolicyTypeEnum';
import { GenericCreatePolicy } from './GenericCreatePolicy';
import { GenericEditPolicy } from './GenericEditPolicy';

export interface IGenericEditCreatePolicyProps {
  policy?: IStandardDocumentVersionData;
  policyType: PolicyTypeEnum;
  isAmericanDigital: boolean;
  label: string;
}

export const GenericEditCreatePolicy: React.FC<IGenericEditCreatePolicyProps> = ({
  policy,
  policyType,
  isAmericanDigital,
  label,
}) => {
  if (policy) {
    return (
      <GenericEditPolicy isAmericanDigital={isAmericanDigital} policy={policy} policyType={policyType} label={label} />
    );
  }
  return <GenericCreatePolicy policyType={policyType} isAmericanDigital={isAmericanDigital} />;
};
